import React, { useRef, useState, useEffect } from 'react';
import BackGroundVideo from "./Home/BackGroundVideo";
import Home from "./Menu2/Home";
import Header from './Header/Header';
import videoSrc1 from './assets/video.mp4';
import Stanovi from './Stanovi/Stanovi';
import StanoviKupovina from './Stanovi/StanoviKupovina';
import NasiAgenti from './Stanovi/NasiAgenti';
import Footer from './Header/Footer';
import VasZahtev from './Header/VasZahtev';
import StanDetail from './Stanovi/StanDetail';
import StanoviPretraga from './Stanovi/StanoviPretraga'; // Dodajemo StanoviPretraga

function App() {
  const homeRef = useRef(null); 
  const [showText, setShowText] = useState(true); 
  const [isHeaderVisible, setIsHeaderVisible] = useState(false); 
  const [showHome, setShowHome] = useState(false);  
  const [isProdaja, setIsProdaja] = useState(false); 
  const [isIznajmljivanje, setIsIznajmljivanje] = useState(false); 
  const [selectedStan, setSelectedStan] = useState(null);  
  const [prevSection, setPrevSection] = useState(null); 
  const [listingType, setListingType] = useState(null); 
  const [isSearching, setIsSearching] = useState(false); 
  const [filteredStanovi, setFilteredStanovi] = useState([]); 
  const [isSearchingFromStanDetail, setIsSearchingFromStanDetail] = useState(false); // Flag za pretragu iz StanDetail
  const [filteredStanoviFromDetail, setFilteredStanoviFromDetail] = useState([]); // Za pretragu iz StanDetail

  const stanoviRef = useRef(null); 
  const stanoviKupovinaRef = useRef(null); 
  const vasZahtevRef = useRef(null);
  const stanoviPretragaRef = useRef(null); 

  const scrollToHome = () => {
    setIsProdaja(false);
    setIsIznajmljivanje(false);
    setSelectedStan(null); 
    setShowHome(true); 
    setIsSearching(false);
    setIsSearchingFromStanDetail(false); // Resetujemo pretragu iz StanDetail
    setTimeout(() => {
      if (homeRef.current) {
        homeRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleStanClick = (stan, type) => {
    setSelectedStan(stan); 
    setListingType(type); 
    setPrevSection(type);  
  };

  const handleBackFromStan = () => {
    setSelectedStan(null); 
    setListingType(null); 

    if (prevSection === 'iznajmljivanje' && stanoviRef.current) {
      stanoviRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (prevSection === 'prodaja' && stanoviKupovinaRef.current) {
      stanoviKupovinaRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (prevSection === 'pretraga' && stanoviPretragaRef.current) {
      stanoviPretragaRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(() => {
    if (!selectedStan) {
      if (prevSection === 'iznajmljivanje' && stanoviRef.current) {
        stanoviRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (prevSection === 'prodaja' && stanoviKupovinaRef.current) {
        stanoviKupovinaRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (prevSection === 'pretraga' && stanoviPretragaRef.current) {
        stanoviPretragaRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [selectedStan, prevSection]);

  const handleIzdavanjeClick = () => {
    setSelectedStan(null);
    setIsIznajmljivanje(true);
    setIsProdaja(false);
    setIsSearching(false);
    setIsSearchingFromStanDetail(false); // Resetujemo pretragu iz StanDetail
    setShowHome(false); 
    setTimeout(() => {
      if (stanoviRef.current) {
        stanoviRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 200);
  };

  const handleProdajaClick = () => {
    setSelectedStan(null);
    setIsProdaja(true);
    setIsIznajmljivanje(false);
    setIsSearching(false);
    setIsSearchingFromStanDetail(false); // Resetujemo pretragu iz StanDetail
    setShowHome(false); 
    setTimeout(() => {
      if (stanoviKupovinaRef.current) {
        stanoviKupovinaRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 200);
  };

  const scrollToVasZahtev = () => {
    setSelectedStan(null);
    if (showHome) {
      setShowHome(false);
      setIsProdaja(false);
      setIsIznajmljivanje(true);
    }
    setTimeout(() => {
      if (vasZahtevRef.current) {
        vasZahtevRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 200);
  };


  const handleSearch = (filteredResults) => {
    setFilteredStanovi(filteredResults); 
    setShowHome(false); 
    setSelectedStan(null);
    setIsSearching(true); // Postavi flag za pretragu iz Home
    setIsSearchingFromStanDetail(false); // Reset pretrage iz StanDetail
    setPrevSection('pretraga'); 
  };
  const handleSearchFromStanDetail = (filteredResults) => {
    setFilteredStanoviFromDetail(filteredResults); // Postavi filtrirane stanove iz StanDetail
    setIsSearchingFromStanDetail(true); // Aktiviraj pretragu iz StanDetail
    setIsSearching(false); // Isključi pretragu iz Home
    setSelectedStan(null);
    setPrevSection('pretraga');
  };
  

  const handleVideoEndOrClick = () => {
    setShowHome(true); 
    setIsHeaderVisible(true);
    if (homeRef.current) {
      homeRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      {isHeaderVisible && (
        <Header 
          onIzdavanjeClick={handleIzdavanjeClick} 
          onProdajaClick={handleProdajaClick} 
          onVasZahtevClick={scrollToVasZahtev}
          onAboutClick={scrollToHome} 
        />
      )}

      {!showHome && !isSearching && !isSearchingFromStanDetail && !isProdaja && !isIznajmljivanje && !selectedStan ? (
        <BackGroundVideo
          videoSrc={videoSrc1}
          showText={showText}
          setShowText={setShowText}
          onEnded={handleVideoEndOrClick}
          onClick={handleVideoEndOrClick} 
        />
      ) : (
        <>
          <div ref={homeRef}> 
            {showHome && !selectedStan && !isIznajmljivanje && !isProdaja && !isSearching && !isSearchingFromStanDetail && (
              <Home setIsHeaderVisible={setIsHeaderVisible} onSearch={handleSearch} handleProdajaClick={handleProdajaClick} 
              handleIzdavanjeClick={handleIzdavanjeClick} />
            )}
          </div>

          <div className="h-screen overflow-y-auto">
            {selectedStan && (
              <StanDetail stan={selectedStan} listingType={listingType} onBack={handleBackFromStan} onSearch={handleSearchFromStanDetail} />
            )}

            {!selectedStan && (
              <>
                {isSearchingFromStanDetail ? (
                  <div ref={stanoviPretragaRef}>  
                    <StanoviPretraga 
                       stanoviData={filteredStanoviFromDetail}
                      onStanClick={handleStanClick} 
                      scrollToHome={scrollToHome} 
                      stanoviPretragaRef={stanoviPretragaRef}  
                    /> 
                  </div>
                ) : isSearching ? (
                  <div ref={stanoviPretragaRef}>  
                    <StanoviPretraga 
                      stanoviData={filteredStanovi} 
                      onStanClick={handleStanClick} 
                      scrollToHome={scrollToHome} 
                      stanoviPretragaRef={stanoviPretragaRef}  
                    /> 
                  </div>
                ) : isIznajmljivanje ? (
                  <div ref={stanoviRef}>
                    <Stanovi scrollToHome={scrollToHome} onStanClick={(stan) => handleStanClick(stan, 'iznajmljivanje')} />
                  </div>
                ) : isProdaja ? (
                  <div ref={stanoviKupovinaRef}>
                    <StanoviKupovina scrollToHome={scrollToHome} onStanClick={(stan) => handleStanClick(stan, 'prodaja')} />
                  </div>
                ) : null}
              </>
            )}

            <NasiAgenti />
            <div ref={vasZahtevRef}>
              <VasZahtev  />
            </div>
            <Footer scrollToHome={scrollToHome} handleProdajaClick={handleProdajaClick} handleIzdavanjeClick={handleIzdavanjeClick} />
          </div>
        </>
      )}
    </div>
  );
}

export default App;
